import React, { useEffect } from 'react';
import { Progress, Typography } from 'antd';
import { goTo, handleApiExceptions, getRedirectPath } from '../../../app_methods';
import { MerchantService, auth } from '../../../services';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { EbPageLoader } from '../../Common';

const ManageSSO = (props) => {
    const initSurveySensum = () => {
        if (window.surveysensum != undefined) {
            const merchant_id = !props.current_user.is_submerchant ? props.current_user.eid : `WID-${props.current_user.id}`;
            window.surveysensum.setUserInfo({ "Name": merchant_id, "Email": merchant_id + "@wire", "Page": "WIRE" });
        }
    };

    const fetchMerchantInfo = (key) => {
        MerchantService.fetch({ key: key }).then((response) => {
            if (response.success) {
                props.updateCurrentUser(response.data.merchant);
                // initSurveySensum();
                redirect(response.data.merchant);
            }else{
                handleApiExceptions(response)
            }
        }).catch((error) => {
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        })
    };

    const redirect = (current_user) => {
        const urlParams = new URLSearchParams(props.history.location.search);
        const next = urlParams.get('next');
        if (next && next.indexOf("/app/easebuzz/sso") == -1) {
            goTo(next, props.history);
        } else {
            const url = getRedirectPath(current_user.user.permissions);
            goTo(url, props.history);
        }
    }

    useEffect(() => {
        MerchantService.get_key().then((response) => {
            if (response.success) {
                props.updateCurrentUser({ key: response.data.key })
                fetchMerchantInfo(response.data.key);
            }
        }).catch((error) => {
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        })
    }, []);

    return <EbPageLoader />
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageSSO);